module.exports = __webpack_public_path__ + "img/85.4910bfc7.jpg";